// export function getFormattedContacts(contacts) {
//   return contacts.map((p) => ({
//     id: p.id?.split(":")?.pop(),
//     idLinkedin: p.id,
//     userName: p.username,
//     image: p.image,
//     firstName: p.firstName,
//     lastName: p.lastName,
//     description: p.description,
//     email: p.email,
//     connectionCount: p.connectionCount,
//     followerCount: p.followerCount,
//     occupation: p.occupation,
//     summary: p.summary,
//     topics: p.topics,
//     who: p.who,
//     notes: [],
//     full: p.full,
//   }));
// }

export function getFormattedContacts(contacts) {
  return contacts.map((p) => ({
    id: p.id?.split(":")?.pop(),
    idLinkedin: p.id,
    ...p,
    notes: [],
  }));
}
